import React from "react";
import "./Bellefont.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Bellefont8images from "../../Media/Bellefont/Bellefont8";
import Bellefont10images from "../../Media/Bellefont/Bellefont10";
import Bellefont12images from "../../Media/Bellefont/Bellefont12";

const imageMap = {
  Bellefont8images,
  Bellefont10images,
  Bellefont12images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="bellefont" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
